import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function WeChat(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 512 512">
      <g>
        <path fill="currentColor" d="M512,320c0-70.688-71.648-128-160-128s-160,57.312-160,128s71.648,128,160,128
          c14.528,0,28.352-2.048,41.76-4.96L480,480l-29.824-59.616C487.552,396.96,512,360.928,512,320z"/>
        <path fill="currentColor" d="M192,32C85.952,32,0,103.648,0,192c0,50.944,28.736,96.128,73.312,125.376L48,368l68.96-29.536
          c14.784,5.248,30.144,9.568,46.56,11.584c-2.24-9.76-3.52-19.776-3.52-30.048c0-88.224,86.112-160,192-160
          c9.696,0,19.168,0.8,28.512,1.952C363.616,87.968,285.696,32,192,32z"/>
      </g>
      <g>
        <circle fill="#fafafa" cx="128" cy="128" r="24"/>
        <circle fill="#fafafa" cx="256" cy="128" r="24"/>
        <circle fill="#fafafa" cx="304" cy="288" r="24"/>
        <circle fill="#fafafa" cx="400" cy="288" r="24"/>
      </g>
    </SvgIcon>
  );
}
